import * as React from 'react';
import { Form, Formik } from 'formik';
import { REPORT_TYPE_SERVER_TO_CLIENT_MAPPING } from '../../../../../../../consts/report';
import { Club } from '../../../../../../../models/club';
import { getClubStartDateWithoutFormatting, getClubFinishDateWithoutFormatting } from '../../../../../../../helpers/accessor/accessor';
import { ReportActions, ReportDateRange, ReportDescription, ReportSection } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Reports/ReportFormUi';
import '../../Clubs.css';

interface Props { onCloseClick: () => void; onSubmit: (data: any, reportType: string) => void; club: Club; }

// report 069
export function PaperAttendanceRegisterClubReportForm({ onCloseClick, onSubmit, club }: Props) {
  const initialValues = {
    dateFrom: new Date(getClubStartDateWithoutFormatting(club)),
    dateTo: new Date(getClubFinishDateWithoutFormatting(club))
  };

  return <Formik initialValues={initialValues} onSubmit={values => onSubmit(values, REPORT_TYPE_SERVER_TO_CLIENT_MAPPING.PAPER_ATTENDANCE_REGISTER_CLUB)}>
    {({ values, setFieldValue }) => <Form className="eReportForm compactClubReportForm"><div className="eReportForm__scroll">
        <ReportDescription>A blank printable register for the selected club, with enrolled students as rows and scheduled sessions as columns.</ReportDescription>
      <ReportSection number={1} title="Reporting period" hint="Choose the club sessions included in the register." required>
        <ReportDateRange
          dateFrom={values.dateFrom}
          dateTo={values.dateTo}
          onChangeFrom={date => {
            setFieldValue('dateFrom', date);
            if (values.dateTo < date) setFieldValue('dateTo', date);
          }}
          onChangeTo={date => setFieldValue('dateTo', date)}
        />
      </ReportSection>
    </div><ReportActions onCancel={onCloseClick} /></Form>}
  </Formik>;
}
